module Meevo.Plugins.EmployeeSupplyUsage {
    "use strict";
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.BlockType> {
        public increments = [];
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            public durationIncrements,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            appSettings?: Components.Common.IAppSettings
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings);
            this.durationIncrements.getIncrements(480, false)
                .then((increments) => {
                    this.increments = increments;
                });
        }
    }
}